import { FormControlLabel, Switch, useTheme } from '@mui/material';
import React from 'react';
import linkedAccountsSectionStyles from '../Accounts/LinkedAccountsSection.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { keyboardFocusVisibleSx } from '../../utils/a11y.utils';

function SelectAll(props) {
	const { t } = useTranslation();
	const theme = useTheme();

	if (props.consentsNum <= 1) {
		return null;
	}

	return (
		<FormControlLabel
			control={
				<Switch
					checked={props.selectAll}
					onChange={props.toggleSelectAll}
					inputProps={{ 'aria-label': t('common.buttons.selectAll') }}
					sx={keyboardFocusVisibleSx}
				/>
			}
			label={t('common.buttons.selectAll')}
			labelPlacement="start"
			sx={{
				...linkedAccountsSectionStyles.changeNumberLink,
				m: 0,
				ml: 'auto',
				flexShrink: 0,
				alignItems: 'center',
				gap: '0.25rem',
				color: theme.palette.primary.main,
				whiteSpace: 'nowrap',
				'& .MuiFormControlLabel-label': {
					fontSize: 'inherit',
					lineHeight: 1.2,
				},
			}}
		/>
	);
}

export default SelectAll;
